import { type DiscoveryMoodsSection } from 'services/store/discovery/types';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import MoodTile from '../MoodTile';
import {
  StyledDiscoveryTiles,
  StyledDiscoverySectionTitle,
} from '../DiscoverySection';

interface Props {
  data: DiscoveryMoodsSection;
}

const MoodsSection = ({ data }: Props) => {
  const { track } = useAnalytics();

  const triggerAnalytics = (genre: string) => {
    track(
      events.discoveryTileGenerateClick({
        type: 'mood',
        genre,
      })
    );
  };
  return (
    <>
      <StyledDiscoverySectionTitle
        data-testid={`mood-tiles-header-${data.title}`}
        id={data.id}
      >
        {data.title}
      </StyledDiscoverySectionTitle>
      <StyledDiscoveryTiles>
        {data.tiles?.map((tile) => (
          <MoodTile
            data={tile}
            key={tile.id}
            onClick={() => triggerAnalytics(tile.title)}
          />
        ))}
      </StyledDiscoveryTiles>
    </>
  );
};

export default MoodsSection;
